import { useEffect } from "react";
import BasicDataTable from "../../DataTable/BasicDataTable";
import BasicSearchComponent from "../../DataTable/BasicSearchComponent";
import { useProductSizes } from "../../../hooks/product/useProductSizes";
import ProductSizePopup from "./ProductSizePopup";

const ProductSizeTable: React.FC = () => {
  const {
    productSizes,
    fetchProductSizes,
    handlerSearchSizes,
    toggleProductSizeStatus,
    loadProductSizeForEdit,

    // modales
    isCreateModalOpen,
    isEditModalOpen,
    openCreateProductSize,
    closeCreateProductSize,
    closeEditProductSize,

    // form submit handler
    handlerAddProductSize,
  } = useProductSizes();

  // ==========================================
  // LOAD on mount
  // ==========================================
  useEffect(() => {
    fetchProductSizes();
  }, []);

  // ==========================================
  // TABLE COLUMNS
  // ==========================================
  const columns = [
    { Header: "Código", accessor: "code" },
    { Header: "Nombre", accessor: "name" },
    {
      Header: 'Estado',
      accessor: 'status',
      Cell: ({ value }) => (
        <span
          className={`inline-flex rounded-full px-3 py-1 text-sm font-medium ${
            value ? 'bg-green-500 text-white' : 'bg-red text-white'
          }`}
        >
          {value ? 'Activo' : 'Inactivo'}
        </span>
      ),
    },
  ];

  // ==========================================
  // HEADER BUTTON
  // ==========================================
  const addButton = (
    <button
      className="inline-flex items-center rounded-md bg-primary px-4 py-2 text-white hover:bg-opacity-90"
      onClick={openCreateProductSize}
    >
      + Nueva Talla
    </button>
  );

  // ==========================================
  // Actions
  // ==========================================
  const actions = [
    {
      key: "edit",
      onClick: (row: any) => {
        loadProductSizeForEdit(row.id);
      },
    },
    {
      key: "toggle",
      onClick: (row: any) => {
        toggleProductSizeStatus(row.id);
      },
    },
  ];

  return (
    <>
      <BasicDataTable
        columns={columns}
        data={productSizes}
        noDataMessage="No hay tallas registradas."
        actions={actions}
        headerButton={addButton}
        searchComponent={
          <BasicSearchComponent onSearch={(params) => handlerSearchSizes(params.name)} />
        }
      />

      {/* CREATE MODAL */}
      <ProductSizePopup
        isOpen={isCreateModalOpen}
        close={closeCreateProductSize}
        onSubmit={handlerAddProductSize}
      />

      {/* EDIT MODAL */}
      <ProductSizePopup
        isOpen={isEditModalOpen}
        close={closeEditProductSize}
        onSubmit={handlerAddProductSize}
      />

    </>
  );
};

export default ProductSizeTable;
